import { TYPE } from "../actions/types";
const initialState = {
    metaDataApiRes: {},
    metaDataApiLoader:true
};

export default function (state = initialState, action, response = action.payload) {
    switch (action.type) {
        case TYPE.GET_APP_HOME_PREVIEW_METADATA:
            state.metaDataApiRes = response
            state.metaDataApiLoader = false
            return {
                ...state, response: response
            }
        case "CLEAR_META_DATA_PREV_RES":
            state.metaDataApiRes = {}
            state.metaDataApiLoader = true
            return {
                ...state, response: response
            }
        default:
            return state;
    }

}